module.exports = __webpack_public_path__ + "img/nt118-01-81-1.prt.4c74eb79.jpg";